import { PageHero } from "@/components/PageHero";
import { CTABand } from "@/components/CTABand";
import Founder from "@/components/Founder";

const FOCUS_AREAS = ["Governance", "Trade", "Health", "Climate Resilience", "Education", "Culture", "Innovation"];

export default function AboutPage() {
  return (
    <main data-testid="about-page">
      <PageHero
        kicker="About the Institute"
        title="Why Atlantic Bridge Exists"
        copy="For generations, Africa–Caribbean relations have often been framed through symbolism, heritage and ceremonial diplomacy. Those connections matter, but they are insufficient on their own."
      />
      <section className="bg-sand py-20 lg:py-28">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 lg:grid-cols-12 lg:gap-12 lg:px-8">
          <div className="lg:col-span-7">
            <h2 className="font-serif text-2xl tracking-tight text-atlantic sm:text-3xl">An Informed Public Record</h2>
            <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
              Atlantic Bridge exists to document what is happening, expose what is missing and create an informed
              public record of what deeper cooperation could achieve. The Institute produces independent journalism,
              research and public-interest projects that connect African and Caribbean societies, institutions and
              people.
            </p>
            <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
              The Atlantic Ocean divided communities, carried forced migration and shaped centuries of political and
              economic history. Today, it can also become a bridge. Atlantic Bridge examines the unfinished
              relationships between Africa and the Caribbean and identifies practical pathways for cooperation.
            </p>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-slate-500">Areas of Work</p>
            <div className="mt-5 flex flex-wrap gap-2.5">
              {FOCUS_AREAS.map((a) => (
                <span
                  key={a}
                  data-testid={`about-focus-${a.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="border border-atlantic/15 bg-white px-4 py-2 text-xs font-semibold tracking-wide text-atlantic/80"
                >
                  {a}
                </span>
              ))}
            </div>
            <div className="mt-10 border-l-2 border-gold pl-5">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-atlantic">Our Standard</p>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                Atlantic Bridge preserves editorial independence and transparency in every partnership and project.{" "}
                <a href="/editorial-standards" data-testid="about-standards-link" className="font-semibold text-ocean underline-offset-4 hover:underline">
                  Read our Editorial Standards
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
      <Founder bio="Victor Kwawukume is a Ghanaian-Canadian journalist, strategic communicator, author and public-interest advocate based in Toronto, Canada. He has more than two decades of experience in journalism, governance reporting, public policy and strategic communications." />
      <CTABand />
    </main>
  );
}
